import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

interface HomepageHeaderArenaContainerBoxProps {
    useSmallHeaderArenas: boolean;
}

const DefaultBox = styled.div<HomepageHeaderArenaContainerBoxProps>`
  display: flex;
  margin-bottom: 4rem;
  margin-top: ${(props) => props.useSmallHeaderArenas ? "0" : "1rem"};
`;

const PCBox = styled(DefaultBox)``;

const MobileBox = styled(DefaultBox)`
  overflow-x: scroll;
  overflow-y: hidden;

  overflow: -moz-scrollbars-none;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    justify-content: flex-start;
  }
`;

export const HomePageHeaderArenasContainerDefaultBox = styledByDevice(PCBox, MobileBox);
